import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F49.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame49() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F49_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F49_entryBox">
                    <div className="F49_paragraph">
                        {language === 'english' ?
                            <p className="F49_paragraphEnglish">With the help of her schoolteacher, Saira has been able to establish a dedicated sanitary station with all the necessary products at her school. Girls are relieved to have running water and sanitary pads available for them at school. </p>
                            :
                            <p className="F49_paragraphUrdu">آپ کی مدد سے سائرہ نے اسکول میں ماہواری کے انتظام کے لئے سینیٹری سٹیشن بنا لیا ہے جہاں پر تمام ضروری اشیاء رکھی گئی ہیں۔ اسکول کی لڑکیاں اس بات خوش ہیں کہ ان کو صفائی ستھرائی کے لئے پانی اور پیڈ سمیت تمام اشیاء اسکول میں ہی دستیاب ہیں۔</p>
                        }
                    </div>

                    <div className="F49_timeline">
                        <div className='F49_timelineBar'>
                            <div className='F49_timelineFill'></div>
                            <span className='F49_timelineText'>19/19</span>
                        </div>
                    </div>

                    <div className="F49_nextFrames">
                        <div className="F49_nextFrame1"></div>
                    </div>

                    <div className='F49_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(19)) }} className='F49_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame49;